import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=ce9642dc&scoped=true"
import script from "./Step5.vue?vue&type=script&lang=js"
export * from "./Step5.vue?vue&type=script&lang=js"
import style0 from "./Step5.vue?vue&type=style&index=0&id=ce9642dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce9642dc",
  null
  
)

export default component.exports